<template>
  <div v-if="image" @mouseover="hovered = true" @mouseleave="hovered = false">
    <nuxt-link v-if="to" :to="to" class="prefooter-links">
      <lazy-image
        :image="image"
        :widths="[720, 1440, 2160]"
        provider="sanity"
      />

      <div class="prefooter-links__content">
        <h2 class="mb-0">{{ title }}</h2>
        <icon name="arrow-right" />
      </div>
    </nuxt-link>
  </div>
</template>

<script>
import LazyImage from '@/components/Image/LazyImage'
import Icon from '@/components/icons/Icon'
import { getSanityBunnyImageLink } from '~/utils/image'

export default {
  name: 'PreFooterLink',
  components: {
    LazyImage,
    Icon,
  },
  props: {
    link: {
      type: Object,
      required: true,
    },
    currentProduct: {
      type: Object,
      default: null,
    },
    nextProduct: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    hovered: false,
  }),
  computed: {
    to() {
      if (
        this.link.type === 'home' &&
        this.currentProduct &&
        this.currentProduct.image
      ) {
        return this.$contextSanityPath(this.currentProduct)
      }

      if (this.link.link.internalLink) {
        return this.$contextSanityPath(this.link.link.internalLink)
      }

      return null
    },
    image() {
      if (
        this.link.type === 'home' &&
        this.currentProduct &&
        this.currentProduct.image
      ) {
        return {
          url: this.currentProduct.image_footer
            ? getSanityBunnyImageLink(this.currentProduct.image_footer, {
                width: 720,
                height: 395,
              })
            : getSanityBunnyImageLink(this.currentProduct.image?.image, {
                width: 720,
                height: 395,
              }),
          dimensions: {
            width: 720,
            height: 395,
          },
        }
      }

      if (
        this.link.type === 'agenda' &&
        this.nextProduct &&
        this.nextProduct.image
      ) {
        return {
          url: this.nextProduct.image_footer
            ? getSanityBunnyImageLink(this.nextProduct.image_footer, {
                width: 720,
                height: 395,
              })
            : getSanityBunnyImageLink(this.nextProduct.image?.image, {
                width: 720,
                height: 395,
              }),
          dimensions: {
            width: 720,
            height: 395,
          },
        }
      }

      if (this.link.link.internalLink?.image) {
        return {
          url: getSanityBunnyImageLink(this.link.link.internalLink?.image, {
            width: 720,
            height: 395,
          }),
          dimensions: {
            width: 720,
            height: 395,
          },
        }
      }
      return null
    },
    title() {
      return this.link.title ?? ''
    },
  },
}
</script>

<style lang="scss">
.prefooter-links {
  position: relative;
  display: block;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      0deg,
      RGB(0 11 21 / 0.5) 0%,
      RGB(0 11 21 / 0) 40.62%
    );
    z-index: 1;
  }

  img {
    transition: transform 0.3s var(--asphalte-animation-function);
  }

  &__content {
    position: absolute;
    inset: auto var(--spacing) calc(var(--spacing) * 1.6);
    z-index: 2;
    display: flex;
    align-items: center;
    color: var(--tertiary-color);

    @include mq($from: tablet) {
      inset: auto calc(var(--spacing) * 2) calc(var(--spacing) * 2);
    }

    h2 {
      color: var(--tertiary-color);
      margin-bottom: 0;
    }

    .icon {
      width: rem(21px);
      height: rem(21px);
      margin-left: calc(var(--spacing) * 1.4);
      transition: all 0.5s var(--asphalte-animation-function);
      opacity: 0;
      transform: translateX(30px);

      @include mq($until: tablet) {
        display: none;
      }
    }
  }

  @include on-hover-and-focus {
    img {
      transform: scale(1.1);
    }

    .icon {
      opacity: 1;
      transform: translateX(0);
    }
  }
}
</style>
